$(window).on("load",function(){
  $("body").animate({opacity:1},700);

  $(".slideshow__media").addClass('active');
 });
  
  

$(document).ready(function() {
  /*
 $('.collection-list_slider').slick({
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: true,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
                 }
        }, 
        {
            breakpoint: 767,
            settings: "unslick"
   
        }]
    });*/

 $('.testimonial_slider').slick({
        dots: false,
        infinite: true,
        speed: 500,
        centerMode: true,
   centerPadding: '100px',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
    responsive: [{
            breakpoint: 767,
            settings: {
                 centerMode: false,
   centerPadding: '0px'
                 }
         
   
        }]
    });

  
// Tab click event
  
  $('.tabs li').click(function() {
    // Remove 'active' class from all tabs and tab content
    $('.tabs li').removeClass('active');
    $('.tab-content').removeClass('active');
    
    // Add 'active' class to clicked tab and corresponding tab content
    var tabId = $(this).data('tab');
    $(this).addClass('active');
    $('#' + tabId).addClass('active');
  });





  
});



  


